import api from '@disco/api/server'
import {
  DISCOVERY_SUITE,
  WATERMARKING,
} from '@disco/constants/billing-provider-components'
import { ContactInformation } from './AddOns'
import type { SubscriptionData } from '@disco/types/types/subscription'
import { getChargebeeAddon } from '@disco/utils/chargebee'

type Props = {
  subscription: SubscriptionData['chargebee']
  billingProviderComponents: any
  type: typeof DISCOVERY_SUITE | typeof WATERMARKING
  value: any
  quota: number
  corePlan: any
  planPeriod: string
  coupon?: string
  contactInformation: ContactInformation
}

type Response = Promise<{
  preview: any

  /*
  For Chargebee:
  - always whole integers, representing cents
  - amounts are EITHER the annual or monthly price, depending on the subscription.
  */
  newFeatureCost: number
  newFeatureCostWithTax: number
}>

const fetchChargebeeComponentCosts = async ({
  type,
  value,
  quota,
  coupon,
  billingProviderComponents,
}: Props): Response => {
  const orderForm = {
    addons: getChargebeeAddon({
      type: type,
      allocated_quantity: Number(value?.value || quota),
      allAddons: billingProviderComponents.addons,
    }),
    coupon: coupon ?? '',
  }

  const estimateResponse = await api.chargebeeEstimateAddons(orderForm)

  return {
    preview: {
      // used only for coupon preview
      current_billing_manifest: {
        total_discount_in_cents: -estimateResponse.discount,
        line_items: estimateResponse.coupons.map(coupon => ({
          kind: 'coupon',
          amount_in_cents: -coupon.amount,
          memo: coupon.coupon_memo,
        })),
      },
    },
    newFeatureCost: estimateResponse.total,
    newFeatureCostWithTax: estimateResponse.total + estimateResponse.tax,
  }
}

const fetchComponentCosts = async (params: Props): Response => {
  return fetchChargebeeComponentCosts(params)
}

export { fetchComponentCosts }
